<script context="module">
  export const SELECTED_COLOR_KEY = Symbol.for('ChromaPicker')
</script>

<script>
  import OpacityPicker from './OpacityPicker.svelte'
  import ColorCanvas from './ColorCanvas.svelte'
  import HueCanvas from './HueCanvas.svelte'
  import Inputs from './Inputs.svelte'
  import selectedColorFn from './selectedColor'
  import { createEventDispatcher, getContext, hasContext, onMount, setContext } from 'svelte'
  import { convertColorStringToHex } from './helpers'

  export let color = null

  const dispatch = createEventDispatcher()
  const selectedColor = hasContext(SELECTED_COLOR_KEY)
    ? getContext(SELECTED_COLOR_KEY)
    : setContext(SELECTED_COLOR_KEY, selectedColorFn())

  let init = false
  $: if (init && $selectedColor) {
    const changed = $selectedColor.hexF !== color
    color = $selectedColor.hexF
    if (changed) dispatch('change', { value: color })
  }

  onMount(() => {
    let hex
    if (color) hex = convertColorStringToHex(color)

    selectedColor.change({ hexF: hex }, $selectedColor)
    init = true
  })
</script>

<div class="mb-3">
  <HueCanvas />
</div>

<div class="mb-3">
  <ColorCanvas />
</div>

<div class="mb-3">
  <OpacityPicker />
</div>

<div>
  <Inputs />
</div>
